module.exports = __webpack_public_path__ + "img/629.5eea6280.jpg";